import { useState } from "react";
import { subscribeNewsletter } from "../api";

export default function NewsletterSection() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [status, setStatus] = useState("");
    const [message, setMessage] = useState("");

    const handleSubscribe = async e => {
        e.preventDefault();
        setStatus("loading");
        try {
            const data = await subscribeNewsletter({ name, email });
            setStatus("success");
            setMessage(data.message || "Subscribed successfully!");
            setName("");
            setEmail("");
        } catch (err) {
            setStatus("error");
            setMessage(err.message);
        }
    };

    const inputStyle = {
        padding: "14px 18px", borderRadius: 12,
        border: "1.5px solid #f0d0d0",
        background: "#fff8f8",
        fontFamily: "'Nunito Sans',sans-serif", fontSize: 14, outline: "none",
        color: "var(--text)",
        transition: "border-color 0.2s"
    };

    return (
        <section style={{ background: "#FDF5F5", padding: "56px 72px" }}>
            <div style={{
                maxWidth: 960, margin: "0 auto",
                background: "white", borderRadius: 28,
                border: "1.5px solid #f0d0d0",
                padding: "48px 60px",
                display: "grid", gridTemplateColumns: "1fr 1fr", gap: 48,
                alignItems: "center",
                boxShadow: "0 8px 40px rgba(192,57,43,0.08)",
                position: "relative", overflow: "hidden"
            }}>
                {/* Decorative corner accent */}
                <div style={{
                    position: "absolute", top: 0, right: 0,
                    width: 180, height: 180,
                    background: "radial-gradient(circle at top right, rgba(192,57,43,0.08), transparent 70%)",
                    pointerEvents: "none"
                }} />
                <div style={{
                    position: "absolute", bottom: 0, left: 0,
                    width: 140, height: 140,
                    background: "radial-gradient(circle at bottom left, rgba(192,57,43,0.05), transparent 70%)",
                    pointerEvents: "none"
                }} />

                {/* Left: copy */}
                <div style={{ position: "relative", zIndex: 1 }}>
                    <div style={{
                        display: "inline-flex", alignItems: "center", gap: 6,
                        background: "linear-gradient(135deg, #8B1A1A, #C0392B)",
                        color: "white", fontSize: 11, fontWeight: 800,
                        padding: "5px 14px", borderRadius: 50, marginBottom: 16,
                        letterSpacing: "0.08em",
                        boxShadow: "0 2px 12px rgba(192,57,43,0.3)"
                    }}>📬 NEWSLETTER</div>
                    <h2 style={{
                        fontFamily: "'Playfair Display',serif", fontSize: 30, fontWeight: 800,
                        lineHeight: 1.2, marginBottom: 10, color: "#1a0505"
                    }}>Get ₹100 Off Your First Order</h2>
                    <p style={{ fontSize: 14, color: "#7a4a4a", lineHeight: 1.7 }}>
                        Subscribe to our weekly reading list and receive exclusive discounts, early access to new launches, and free chapter previews.
                    </p>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 12, marginTop: 20 }}>
                        {["📦 No spam", "🎁 Welcome discount", "📚 Weekly reads"].map(b => (
                            <span key={b} style={{ fontSize: 12, color: "#c0605a", fontWeight: 600 }}>{b}</span>
                        ))}
                    </div>
                </div>

                {/* Right: form */}
                <div style={{ position: "relative", zIndex: 1 }}>
                    <form onSubmit={handleSubscribe} style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                        <input
                            value={name}
                            onChange={e => setName(e.target.value)}
                            placeholder="Your full name"
                            required
                            style={inputStyle}
                            onFocus={e => e.currentTarget.style.borderColor = "#C0392B"}
                            onBlur={e => e.currentTarget.style.borderColor = "#f0d0d0"}
                        />
                        <input
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            type="email"
                            placeholder="Your email address"
                            required
                            style={inputStyle}
                            onFocus={e => e.currentTarget.style.borderColor = "#C0392B"}
                            onBlur={e => e.currentTarget.style.borderColor = "#f0d0d0"}
                        />
                        <button
                            type="submit"
                            disabled={status === "loading"}
                            style={{
                                padding: "14px", width: "100%", fontSize: 15, fontWeight: 700,
                                background: status === "loading"
                                    ? "#c07070"
                                    : "linear-gradient(135deg, #C0392B, #96221A)",
                                color: "white", border: "none", borderRadius: 12,
                                cursor: status === "loading" ? "not-allowed" : "pointer",
                                fontFamily: "'Nunito Sans',sans-serif",
                                boxShadow: "0 4px 18px rgba(192,57,43,0.35)",
                                transition: "all 0.2s"
                            }}
                        >
                            {status === "loading" ? "Subscribing..." : "Subscribe & Get ₹100 Off →"}
                        </button>
                    </form>
                    {status === "success" && (
                        <div style={{ fontSize: 13, color: "#27ae60", marginTop: 10, textAlign: "center", fontWeight: 700 }}>
                            ✓ {message}
                        </div>
                    )}
                    {status === "error" && (
                        <div style={{ fontSize: 13, color: "#C0392B", marginTop: 10, textAlign: "center", fontWeight: 700 }}>
                            {message}
                        </div>
                    )}
                    {!status && (
                        <div style={{ fontSize: 11, color: "#c0a0a0", marginTop: 10, textAlign: "center" }}>
                            🔒 We respect your privacy. Unsubscribe anytime.
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
}